import { ScanReportType } from "@sscs/types";
import { SharedReportOptions, SharedToken } from "Types";

export const USE_CASE_LABEL = {
  vendor: "Vendor (publisher of software package)",
  customer: "Customer (buyer of software package)",
  internalStakeholder:
    "Internal stakeholder (security, development, compliance)",
  externalAuditor: "External auditor (3rd party assessor, regulator)",
  customerSupport: "ReversingLabs Support (customer support)",
} as const;

export type LinkNameUseCase = keyof typeof USE_CASE_LABEL;

export type SharedReportInfo = SharedToken;

export type SharedReportLinkNameForm = {
  label: string;
  use_case?: LinkNameUseCase;
};

export type SharedReportRestrictionsForm = {
  expires_in: number;
} & SharedReportOptions;

export type SharedReportPreviousRecipientsForm = {
  recipients: string[];
};

export type SharedReportRecipientsForm = SharedReportPreviousRecipientsForm & {
  message: string | undefined;
  send_copy_to_me: boolean;
};

export type SharedReportForm = SharedReportLinkNameForm &
  SharedReportRestrictionsForm &
  SharedReportRecipientsForm;

export type ShareReportRequest = {
  version_id: string;
  report_type?: ScanReportType;
  settings: Omit<SharedReportForm, "send_copy_to_me" | "use_case">;
};

export type ShareReportResponse = SharedToken;

export type UnshareReportRequest = {
  token_key: string;
};

export type UpdateReportLinkRequest = {
  token_key: string;
  body: {
    label: string;
  };
};

export type DeleteReportLinkRequest = {
  token_key: string;
};

export type LinksTableFilter = {
  active_only?: boolean;
};

export type LinksTableSort = {
  property: "label" | "user" | "expiry";
  reverse: boolean;
};

export type SharedReportLinksResponse = {
  match_count: number;
  shared_reports: SharedToken[];
};

export type SharedReportLinksRequest = {
  version_id: string;
  report_type?: ScanReportType;
  /** limit number of returned results */
  limit?: number;
  /** offset returned results */
  offset?: number;
  sort: LinksTableSort;
  filter: LinksTableFilter;
};

export type SharedReportLinkRecipient = {
  email: string;
  last_opened: string | null;
};

export type SharedReportLinkRecipientResponse = SharedReportLinkRecipient[];

export type SharedReportLinkRecipientRequest = {
  token_key: string;
};

export type SendReportInvitesResponse = SharedToken;

export type SendReportInvitesRequest = {
  token_key: string;
  recipients: SharedReportForm["recipients"];
  message: SharedReportForm["message"];
};

export type PurlComponents = {
  projectName: string;
  packageName: string;
  version: string;
};
